import * as t from './actionTypes';

export const initialState = {
  navComponentKey: undefined as string | undefined,
};

export type NavState = typeof initialState;
export type NavAction = { type: string; key?: string };

export const navReducer = (state: NavState = initialState, action: NavAction): NavState => {
  switch (action.type) {
    case t.CLOSE_NAV: {
      return {
        ...state,
        navComponentKey: undefined,
      };
    }
    case t.OPEN_NAV: {
      return {
        ...state,
        navComponentKey: action.key,
      };
    }
    case t.TOGGLE_NAV: {
      const navComponentKey = action.key === state.navComponentKey ? undefined : action.key;

      return {
        ...state,
        navComponentKey,
      };
    }
    default: {
      return state;
    }
  }
};
